import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

const { hash, deployTime } = environment.versionInfo;
console.log(
  `%c[DEPLOY]%c${hash} %c(${deployTime})`,
  'color: white; background: #333; padding: 2px 4px; border-radius: 3px; margin-right: 6px;',
  '',
  'color: #9e9e9e;',
);

bootstrapApplication(App, appConfig).catch(err => console.error(err));
